

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {ConfigAlerta} from '@/model/resource/ConfigAlerta'
import {ConfigAlertaCollection} from '@/model/collection/ConfigAlertaCollection'
import {ListConfigAlertaSchema} from '@/schema/resource/ConfigAlerta/ListConfigAlertaSchema'
import {CsvConfigAlertaSchema} from '@/schema/resource/ConfigAlerta/CsvConfigAlertaSchema'

@Component
export default class ListConfigAlertaView extends Mixins(MixinQueryRouter) {
  schema = new ListConfigAlertaSchema()
  collection = new ConfigAlertaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ConfigAlerta) {
    Helper.pushByName('editConfigAlerta', item.$id)
  }

  async removeItem(item: ConfigAlerta) {
    await new DialogRemove(item).confirm(() => item.removeConfigAlerta())
    await this.collection.listConfigAlerta()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ConfigAlertaCollection().clearFilters().addFilter(params)

    await csv.listCsvConfigAlerta()
    new CsvConfigAlertaSchema().downloadCsv(csv.all())
  }
}
